import { Component, OnInit } from '@angular/core';
import { MetaDataService } from '../metadata.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'tea-shop-fe-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  standalone: false
})
export class NotFoundComponent implements OnInit {

  originalUrl = '';

  constructor(
    private metaDataService: MetaDataService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.metaDataService.updateMetadata({
      title: 'Page Not Found - Sencha Tea',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
  }

  ngOnInit() {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.previousNavigation) {
      this.originalUrl = navigation.previousNavigation.finalUrl?.toString() || '';
    } else if (!this.route.snapshot.data['isDirectNavigation']) {
      this.originalUrl = this.router.url;
    } else {
      this.originalUrl = '';
    }
    // TODO : We'll do something with this later like a database lookup for suggestions or logging
  }

}
